import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';
import { fetchTrades } from "../../WorkArea/Trades/Trades.sagas";

export function* fetchTransactions(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/ebayTransactions/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
      sort: payload.filters.sort,
    }
  });
  yield put({
    // $global: true,
    type: 'SET_TRANSACTIONS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateTransaction(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/ebayTransactions/update', {
    body: {
      _id: payload.data._id,
      data: payload.data,
    }
  });
  yield fetchTransactions(action);
  yield put({ type: 'TRANSACTION_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_TRANSACTIONS', fetchTransactions),
    takeFirst('UPDATE_TRANSACTION', updateTransaction),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/Transactions.sagas.js